module.exports = __webpack_public_path__ + "img/Boat.a4d9d846.png";